import Vue from 'vue'
import App from './App.vue'
import assetsSystem from './shared/assets-system'
import sizeSystem from './shared/size-system'
import debug from 'debug'
import soundMap from './shared/sounds.json'
import soundSystem from './shared/sound-system'
debug.disable()

Vue.config.productionTip = false

const init = async () => {
  await sizeSystem.init()
  await assetsSystem.init()
  await soundSystem.registerSoundMap('vault', soundMap)
  //await tweakpaneManager.init()
  //await debugSystem.init()
  //touchSystem.mount()

  new Vue({
    el: '#app',
    render: h => h(App)
  })
}

init()
